import CrmCenteredTitle from '../../../components/CrmCenteredTitle';
import React, { useState } from 'react';
import CrmLayout from '../../../components/CrmLayout';
import { useNavigate, useParams } from 'react-router-dom';
import { useQuery } from '@apollo/client';
import { QUERY_CLIENT } from '../../../graphql/user';
import { Empty, Pagination } from 'antd';
import _ from 'lodash';
import cls from './ClientSubscriptions.module.scss';
import { QUERY_SUBSCRIPTIONS } from '../../../graphql/subscription';
import SubscriptionCard from './SubscriptionCard';
import { subscription_new } from '../../../routes';

export function ClientSubscriptions() {
    const { id } = useParams();
    const [page, setPage] = useState(1);
    const navigate = useNavigate();

    const query = useQuery(QUERY_CLIENT, {
        variables: {
            id: id,
            messages_sort: ['createdAt:DESC'],
            messages_pagination: {
                page: page,
                pageSize: 20,
            },
        },
    });

    const client =
        query.data?.usersPermissionsUser?.data?.attributes?.client?.data ||
        query.data?.usersPermissionsUser?.data?.attributes?.parent?.data;
    const title = `${client?.attributes?.firstName} ${client?.attributes?.lastName}`;

    const subscriptions = useQuery(QUERY_SUBSCRIPTIONS, {
        variables: {
            filters: {
                user: {
                    id: {
                        eq: id,
                    },
                },
            },
            pagination: {
                page: page,
                pageSize: 20,
            },
            sort: ['createdAt:DESC'],
        },
    });

    return (
        <CrmLayout>
            <CrmCenteredTitle title={`${title} – Абонементы`} addAction={() => navigate(subscription_new(id))}/>

            <div className={cls.blocks}>

                {subscriptions.data?.subscriptions?.data?.length === 0 && <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />}

                {_.map(subscriptions.data?.subscriptions?.data, (subscription) => (
                    <SubscriptionCard id={subscription.id} data={subscription} />
                ))}
            </div>

            <Pagination
                className={'crm-task-pagination'}
                defaultCurrent={1}
                current={page}
                total={client?.attributes?.messages?.meta?.total}
                pageSize={20}
                onChange={(page) => {
                    setPage(page);
                }}
            />
        </CrmLayout>
    );
}
